import { queryParams, request, extractResponseData } from './api'
const routeApi = '/api/User/'

// Get all users
export async function getUsers(req) {
  const query = req ? queryParams(req) : ''
  const url = `${routeApi}GetUsers${query}`
  try {
    const response = await request('GET', url, {}, true)
    return extractResponseData(response)
  } catch (error) {
    console.error('Error in getUsers:', error)
    throw error
  }
}

// Get a user by ID
export async function getUserById(id) {
  const url = `${routeApi}GetUserById?id=${id}`
  try {
    const response = await request('GET', url, {}, true)
    return extractResponseData(response)
  } catch (error) {
    console.error('Error in getUserById:', error)
    throw error
  }
}

// Create a new user — body { Username, Password, PlantNo, Firstname, Lastname, Email, Role }
export async function createUser(userData) {
  const url = `${routeApi}CreateUser`
  try {
    const response = await request('POST', url, userData, true)
    return extractResponseData(response)
  } catch (error) {
    if (error?.response?.data) {
      return extractResponseData(error.response)
    }
    console.error('Error in createUser:', error)
    throw error
  }
}

// Update an existing user — body { Id, Firstname, Lastname, Email, Role, Status } (no Username/Password/PlantNo)
export async function updateUser(userData) {
  const url = `${routeApi}UpdateUser`
  const payload = {
    id: userData.id,
    firstname: userData.firstname,
    lastname: userData.lastname,
    email: userData.email,
    role: userData.role,
    status: userData.status,
  }
  try {
    const response = await request('PUT', url, payload, true)
    return extractResponseData(response)
  } catch (error) {
    if (error?.response?.data) {
      return extractResponseData(error.response)
    }
    console.error('Error in updateUser:', error)
    throw error
  }
}

// Delete a user by ID
export async function deleteUser(id) {
  const url = `${routeApi}DeleteUser/${id}`
  try {
    const response = await request('DELETE', url, {}, true)
    return extractResponseData(response)
  } catch (error) {
    console.error('Error in deleteUser:', error)
    throw error
  }
}

// Self-service change password (used by ForceChangePasswordModal + future profile page)
export async function changePassword({ currentPassword, newPassword }) {
  const url = `${routeApi}ChangePassword`
  try {
    const response = await request('POST', url, { currentPassword, newPassword }, true)
    return extractResponseData(response)
  } catch (error) {
    if (error?.response?.data) {
      return extractResponseData(error.response)
    }
    console.error('Error in changePassword:', error)
    throw error
  }
}

// Admin reset password of a target user — body { userId, newPassword }
export async function adminResetPassword({ userId, newPassword }) {
  const url = `${routeApi}AdminResetPassword`
  try {
    const response = await request('POST', url, { userId, newPassword }, true)
    return extractResponseData(response)
  } catch (error) {
    if (error?.response?.data) {
      return extractResponseData(error.response)
    }
    console.error('Error in adminResetPassword:', error)
    throw error
  }
}
